if (!customElements.get('delivery-promise')) {
  customElements.define(
    'delivery-promise',
    class DeliveryPromise extends HTMLElement {
      static cacheDuration = 30 * 60 * 1000;

      connectedCallback() {
        this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
          if (event.data.sectionId !== this.dataset.section) return;
          const { variant } = event.data;
          this.update(variant.available ? variant.sku : '');
        });
        this.update(this.dataset.sku);
      }

      disconnectedCallback() {
        this.variantChangeUnsubscriber();
      }

      async update(sku) {
        this.sku = sku;
        const option = sku ? await this.fetchPromise(sku).catch(() => null) : null;
        if (sku !== this.sku) return;

        // Sans promesse, on vide le texte sans masquer le bloc : sa place reste réservée, sinon la page remonte.
        this.querySelector('.delivery-promise__text').textContent =
          option?.status === 'valid' ? this.format(option) : '';
      }

      async fetchPromise(sku) {
        const { country, route } = this.dataset;
        const cacheKey = `delivery-promise:${sku}:${country}:${route}`;
        const cached = JSON.parse(sessionStorage.getItem(cacheKey));
        if (cached && cached.expires > Date.now()) return cached.option;

        const response = await fetch('/apps/onestock/proxy/delivery_promises', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            payload: {
              line_items: [{ item_id: sku, qty: 1 }],
              sales_channel: 'sc_ecom',
              delivery_options: [{ delivery_method: route, destination: { location: { country } } }],
            },
          }),
        });
        if (!response.ok) return null;

        const option = (await response.json()).delivery_options?.[0] ?? null;
        const expires = Math.min(
          Date.now() + DeliveryPromise.cacheDuration,
          option?.cutoff ? option.cutoff * 1000 : Infinity
        );
        sessionStorage.setItem(cacheKey, JSON.stringify({ expires, option }));
        return option;
      }

      format(option) {
        const date = new Intl.DateTimeFormat(document.documentElement.lang, { day: 'numeric', month: 'long' }).format(
          option.eta_start * 1000
        );
        return this.dataset.label.replace('[date]', date);
      }
    }
  );
}
